import { Component, OnInit, Input, ViewChild } from '@angular/core';
// import { APIService } from 'src/app/API.service';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { ContentTypeCrudService } from 'src/app/shared/services/content-type-crud.service';
import { ContentType } from 'src/app/shared/interfaces/content-type';

@Component({
  selector: 'app-content-type',
  templateUrl: './content-type.component.html',
  styleUrls: ['./content-type.component.scss']
})
export class ContentTypeComponent implements OnInit {

  checked2: boolean = false;

  contentTypes: ContentType[];
  contentType: ContentType;
  selectedContentTypes: ContentType[] = [];

  contentTypeDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  constructor(
   // private api: APIService,
    private contentTypeService : ContentTypeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Content types'}
    ];

    this.contentTypes = [];
    this.contentType = { } as ContentType ;
    //this.getAllRecords();
  }

  ngOnInit(): void {
    
    this.dataState();
    let s = this.contentTypeService.GetContentTypesList(); 
    s.snapshotChanges().subscribe(data => {
      this.contentTypes = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          this.contentTypes.push(jsonItem as ContentType);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'inputable', header: 'In' },
      { field: 'outputable', header: 'Out' },
    
      { field: 'actions', header: 'Actions' } 
    ];

    this._selectedColumns = this.cols;

    // Exports
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));
  }

  dataState() {     
    this.contentTypeService.GetContentTypesList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.ContentTypes);
            doc.save('content-types.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.contentTypes);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "content-types");
    });
  }

  exportDTCSV() {
    console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    //this.exportService.exportToCsv(this.contentTypes, 'ContentTypes', ['companyId', 'companyName', '$key', 'actions']);
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => exportCols.push(sc.field));
    this.exportService.exportToCsv(this.selectedContentTypes, 'content-types', exportCols);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.contentType = {} as ContentType;
    this.submitted = false;
    this.contentTypeDialog = true;
  }

  deleteSelectedContentTypes() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected Content Types?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.contentTypes = this.contentTypes.filter(val => !this.selectedContentTypes.includes(val));
          this.contentTypes.forEach( pallet => {
            this.contentTypeService.DeleteContentType(pallet.$key);
          } );
          
          this.selectedContentTypes = [];
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content types deleted', life: 3000});
      }
  });
  }

  editContentType(contentType: ContentType) {
    this.contentType = {...contentType};
    this.contentTypeDialog = true;
  }

  deleteContentType(contentType: ContentType) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + contentType.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.contentTypes = this.contentTypes.filter(val => val.$key !== contentType.$key);
            this.contentType = {} as ContentType;
            this.contentTypeService.DeleteContentType(contentType.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.contentTypeDialog = false;
    this.submitted = false;
  }

  saveContentType() {
    this.submitted = true;
    if (this.contentType.$key) {
      this.contentTypes[this.findIndexById(this.contentType.$key)] = this.contentType;                
      this.contentTypeService.UpdateContentType(this.contentType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Updated', life: 3000});
    } else {
      // this.pallet.id = this.createId();
      // this.pallet.image = 'product-placeholder.svg';
      this.contentTypeService.AddContentType(this.contentType);
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Content Type Created', life: 3000});
      this.contentTypes = [...this.contentTypes];
    }
    this.contentTypeDialog = false;
    this.contentType = { } as ContentType;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.contentTypes.length; i++) {
        if (this.contentTypes[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeContentType(contentType : ContentType) {
    const contentTypeTmp = {
      ...contentType
    };
    console.log("SAVE", contentTypeTmp);
    this.contentTypeService.UpdateContentType(  contentTypeTmp );
  }

}
